export default __webpack_public_path__ + "static/media/Plywood_Khaya.979dc9b7.JPG";